import React, { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Select } from 'antd';
import { Query } from '../../utils';
import { NewDelivery, NewOwn, NewOther, NewBigBagOrder } from './orders/_orders';
import { NotFound } from '../../pages';

const NewOrder = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const query = useMemo(() => Query.decode(location.search), [location.search]);
	const { type = '0' } = query;

	const select = (
		<Select
			size="large"
			value={type}
			onChange={(type) => navigate(`?${Query.encode({ ...query, type })}`, { replace: true })}
		>
			<Select.Option value="0">Podstawienie</Select.Option>
			<Select.Option value="1">Własne</Select.Option>
			<Select.Option value="2">Inne</Select.Option>
			<Select.Option value="3">Big bag</Select.Option>
		</Select>
	);

	switch (type) {
		case '0':
			return <NewDelivery select={select} />;
		case '1':
			return <NewOwn select={select} />;
		case '2':
			return <NewOther select={select} />;
		case '3':
			return <NewBigBagOrder select={select} />;
	}

	return <NotFound />;
};

export default NewOrder;
